module.exports = __webpack_public_path__ + "img/375.342bc189.jpg";